const $ = require('jquery');

const restrictLength = function() {
	$('input[type=number][max]:not([max=""])').on('input', function() {
	    var $this = $(this);
	    var maxlength = $this.attr('max').length + 1;
	    var value = $this.val();
	    if (value && value.length >= maxlength) {
	    	$this.val(value.substr(0, maxlength));
	    }
	});
};

module.exports = restrictLength;
